import { callApi } from "../../utils/common.utils";
import { format } from "date-fns/format";

export const formatDate = (date?: Date, formatStr = "MM/dd/yyyy") => {
  return date ? format(date, formatStr) : "";
};

export const fetchBenchmarkQuotes = async (
  userId: string,
  startDate?: Date,
  endDate?: Date
) => {
  const newstartDate = formatDate(startDate);
  const newendDate = formatDate(endDate);
  const payLoad = {
    id: userId,
    startDate: newstartDate,
    endDate: newendDate,
  };
  return callApi("getQuotes", payLoad, "getData");
};

export const fetchApprovalQuote = async (userId: number) => {
  const payLoad = {
    quote_id: userId,
  };
  return callApi("getApprovalQuote", payLoad, "getData");
};

export const updateSingleApprovalQuote = async (
  quoteId: number,
  approvedBy: string,
  approvedById: string,
  customerPO: string,
  dateApproved?: Date
) => {
  const newDateApproved = formatDate(dateApproved);
  const payLoad = {
    quote_id: quoteId,
    approvedby: approvedBy,
    approvedbyid: approvedById,
    dateapproved: newDateApproved,
    customerpo: customerPO,
  };
  return callApi("updateApprovalQuote", payLoad, "updateData");
};

export const updateSingleRejectQuote = async (
  quoteId: number,
  rejectionReason: string,
  dateRejected?: Date
) => {
  const newDateRejected = formatDate(dateRejected);
  const payLoad = {
    quote_id: quoteId,
    rejectionReason: rejectionReason,
    dateRejected: newDateRejected,
  };
  return callApi("updateRejectQuote", payLoad, "updateData");
};

export const printBenchmarkQuote = async (
  userId: string | null,
  quotesId: number
) => {
  const payLoad = {
    id: userId,
    quotesId,
  };
  return callApi("printQuote", payLoad, "getData");
};

export const quoteToJob = async (quotesId: number) => {
  const payLoad = {
    quotesId,
  };
  return callApi("quoteToJob", payLoad, "addData");
};
